import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { TransferContainerProps } from "../../../interfaces/containers";
import Transfer from "../../../pages/Profile/MyPublications/Transfer";
import { cleanTransferPublication, getMyPublicationsRequest, getSellers, putTransferPublication } from "../../../actions/profile";

function mapStateToProps(state: TransferContainerProps) {
    return {
        transfer: state.profile.transfer
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        putTransferPublication,
        getSellers,
        cleanTransferPublication,
        getMyPublicationsRequest
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Transfer);